import { isDefined } from '@eih-netbroker/common';
import { ReactNode } from 'react';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close-line.svg';
import { cssWhen } from '../../utils/themeUtils';
import { NbIconButton } from '../icon-button/IconButton';
import { Dialog } from './Dialog';
import classes from './TextHeaderDialog.module.scss';

export type TextHeaderDialogProps = {
  headerText: string;
  content: ReactNode;
  footer: ReactNode;
  customHeaderClassName?: string;
  withHeaderDivider?: boolean;
  withFooterDivider?: boolean;
  withCloseButton?: boolean;
  closeButtonAction?: () => void;
  closeButtonDisabled?: boolean;
};

export const TextHeaderDialog = ({
  headerText,
  content,
  footer,
  customHeaderClassName,
  withHeaderDivider,
  withFooterDivider,
  withCloseButton,
  closeButtonAction,
  closeButtonDisabled,
}: TextHeaderDialogProps) => {
  return (
    <Dialog
      header={
        <div className={classes.header}>
          <span
            data-testid="text-header-dialog-title"
            className={cssWhen(classes.headerText, [isDefined(customHeaderClassName), customHeaderClassName!])}
          >
            {headerText}
          </span>
          {withCloseButton && (
            <NbIconButton
              onClick={closeButtonAction}
              icon={<CloseIcon />}
              disabled={closeButtonDisabled}
              data-testid="text-header-dialog-close-button"
            />
          )}
        </div>
      }
      content={content}
      footer={<div className={classes.footer}>{footer}</div>}
      withHeaderDivider={withHeaderDivider}
      withFooterDivider={withFooterDivider}
    />
  );
};
